import React, { Component } from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'

export default class Experience extends Component {
    render() {
        return (
            <>
                <div id="Experience" className="exp-main headding">
                    <div className="exp ">
                        <h1 className="text-center title">Experience</h1>
                    </div>
                    <Container >
                        <Row >
                            <Col lg={6} md={6} sm={6}>
                                <div className="exp-card">
                                    <Card className="exp-block">
                                        <Card.Body className="exp-body">
                                            <Card.Title className="exp-title">Visual Designer
                                                <p>
                                                    2017-2018 | Full Time | InHouse
                                                </p>
                                            </Card.Title>
                                            <hr />
                                            <Card.Text className="exp-text">
                                                Lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod tempor incididunt ut dolor sit amet consectetur adipisicing elit sed do  labore et dolo...
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </Col>
                            <Col lg={6} md={6} sm={6}>
                                <div className="exp-card">
                                    <Card className="exp-block">
                                        <Card.Body className="exp-body">
                                            <Card.Title className="exp-title">Visual Designer
                                                <p>
                                                    2017-2018 | Full Time | InHouse
                                                </p>
                                            </Card.Title>
                                            <hr />
                                            <Card.Text className="exp-text">
                                                Lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod tempor incididunt ut dolor sit amet consectetur adipisicing elit sed do  labore et dolo...
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </Col>
                            <Col lg={6} md={6} sm={6}>
                                <div className="exp-card">
                                    <Card className="exp-block">
                                        <Card.Body className="exp-body">
                                            <Card.Title className="exp-title">Visual Designer
                                                <p>
                                                    2017-2018 | Full Time | InHouse
                                                </p>
                                            </Card.Title>
                                            <hr />
                                            <Card.Text className="exp-text">
                                                Lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod tempor incididunt ut dolor sit amet consectetur adipisicing elit sed do  labore et dolo...
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </Col>
                            <Col lg={6} md={6} sm={6}    >
                                <div className="exp-card">
                                    <Card className="exp-block">
                                        <Card.Body className="exp-body">
                                            <Card.Title className="exp-title">Visual Designer
                                                <p>
                                                    2017-2018 | Full Time | InHouse
                                                </p>
                                            </Card.Title>
                                            <hr />
                                            <Card.Text className="exp-text">
                                                Lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod tempor incididunt ut dolor sit amet consectetur adipisicing elit sed do  labore et dolo...
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        )
    }
}